module.exports = __webpack_public_path__ + "assets/img/1209.414ebfcf.svg";